import { Separator } from "#app/components/ui/separator.js"
import { BUSINESS, APP_PRODUCTION_URL, APP_NAME } from "#app/utils/constants"
import { generateMeta } from "#app/utils/meta.js"
import routes from "#routes/index.js"
import {
	LegalContainer,
	LegalHeading1,
	LegalHeading2,
	LegalListItem,
	LegalParagraph,
	LegalSection,
	LegalSubtitle,
	LegalUnorderedList,
} from "./__utils"

export const meta = generateMeta({
	title: `Cookies | ${APP_NAME}`,
	description: `Investiga sobre cómo, cuando y por qué usamos cookies en ${APP_NAME}.`,
	canonical: routes.public.cookie_policy.route(),
})

export default function Cookies() {
	return (
		<LegalContainer>
			<LegalSection>
				<div>
					<LegalHeading1>Política de cookies</LegalHeading1>
					<LegalSubtitle>
						Mejorando tu experiencia en nuestro sitio web
					</LegalSubtitle>
				</div>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalHeading2>¿Qué son las cookies?</LegalHeading2>

				<LegalParagraph>
					Las cookies son archivos que se pueden descargar en tu equipo a través
					de las páginas web. Son herramientas que tienen un papel esencial para
					la prestación de numerosos servicios de la sociedad de la
					información.Entre otros, permiten a una página web almacenar y
					recuperar información sobre los hábitos de navegación de un usuario o
					de su equipo y, dependiendo de la información obtenida, se pueden
					utilizar para reconocer al usuario y mejorar el servicio ofrecido.
				</LegalParagraph>
				<LegalParagraph>
					Las cookies son esenciales para el correcto funcionamiento de
					Internet, aportando innumerables ventajas en la prestación de
					servicios interactivos, facilitándote la navegación y usabilidad de
					nuestra web.
				</LegalParagraph>
				<LegalParagraph>
					Las cookies ayudan a adaptar las webs a tus necesidades personales y
					no pueden dañar tu equipo. Si las activas pueden ayudar a identificar
					y resolver errores, así como a mejorar la navegabilidad de las páginas
					web.
				</LegalParagraph>
				<LegalParagraph>
					Las cookies permiten a una página web, entre otras cosas, almacenar y
					recuperar información sobre las preferencias de navegación de un
					usuario o de su equipo.
				</LegalParagraph>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalHeading2>
					Tipos de cookies que utilizamos en {BUSINESS.name}
				</LegalHeading2>

				<LegalParagraph>
					Según quién sea la entidad que gestione el dominio desde donde se
					envían las cookies y trate los datos que se obtengan se pueden
					distinguir dos tipos:
				</LegalParagraph>

				<LegalUnorderedList>
					<LegalListItem>
						Cookies propias: Aquellas que se envían al equipo terminal del
						usuario desde un equipo o dominio gestionado por el propio editor y
						desde el que se presta el servicio solicitado por el usuario.
					</LegalListItem>
					<LegalListItem>
						Cookies de terceros: Aquellas que se envían al equipo terminal del
						usuario desde un equipo o dominio que no es gestionado por el
						editor, sino por otra entidad que trata los datos obtenidos través
						de las cookies. En el caso de que las cookies sean instaladas desde
						un equipo o dominio gestionado por el propio editor pero la
						información que se recoja mediante éstas sea gestionada por un
						tercero, no pueden ser consideradas como cookies propias.
					</LegalListItem>
				</LegalUnorderedList>

				<LegalParagraph>
					Existe también una segunda clasificación según el plazo de tiempo que
					permanecen almacenadas en el navegador del cliente, pudiendo tratarse
					de:
				</LegalParagraph>

				<LegalUnorderedList>
					<LegalListItem>
						Cookies de sesión: Diseñadas para recabar y almacenar datos mientras
						el usuario accede a una página web. Se suelen emplear para almacenar
						información que solo interesa conservar para la prestación del
						servicio solicitado por el usuario en una sola ocasión, como por
						ejemplo una lista de productos adquiridos.
					</LegalListItem>
					<LegalListItem>
						Cookies persistentes: Los datos siguen almacenados en el terminal y
						pueden ser accedidos y tratados durante un periodo definido por el
						responsable de la cookie, y que puede ir de unos minutos a varios
						años.
					</LegalListItem>
				</LegalUnorderedList>

				<LegalParagraph>
					Por último, existe otra clasificación con seis tipos de cookies según
					la finalidad para la que se traten los datos obtenidos:
				</LegalParagraph>

				<LegalUnorderedList>
					<LegalListItem>
						Cookies técnicas: Aquellas que permiten al usuario la navegación a
						través de una página web, plataforma o aplicación y la utilización
						de las diferentes opciones o servicios que en ella existan como, por
						ejemplo, controlar el tráfico y la comunicación de datos,
						identificar la sesión, acceder a partes de acceso restringido,
						recordar los elementos que integran un pedido, realizar el proceso
						de compra de un pedido, realizar la solicitud de inscripción o
						participación en un evento, utilizar elementos de seguridad durante
						la navegación, almacenar contenidos para la difusión de vídeos o
						sonido o compartir contenidos a través de redes sociales.
					</LegalListItem>
					<LegalListItem>
						Cookies de personalización: Permiten al usuario acceder al servicio
						con algunas características de carácter general predefinidas en
						función de una serie de criterios en el terminal del usuario como
						por ejemplo serian el idioma, el tipo de navegador a través del cual
						accede al servicio, la configuración regional desde donde accede al
						servicio, etc.
					</LegalListItem>
					<LegalListItem>
						Cookies de análisis: Permiten al responsable de las mismas, el
						seguimiento y análisis del comportamiento de los usuarios de los
						sitios web a los que están vinculadas. La información recogida
						mediante este tipo de cookies se utiliza en la medición de la
						actividad de los sitios web, aplicación o plataforma y para la
						elaboración de perfiles de navegación de los usuarios de dichos
						sitios, aplicaciones y plataformas, con el fin de introducir mejoras
						en función del análisis de los datos de uso que hacen los usuarios
						del servicio.
					</LegalListItem>
					<LegalListItem>
						Cookies publicitarias: Permiten la gestión, de la forma más eficaz
						posible, de los espacios publicitarios.
					</LegalListItem>
					<LegalListItem>
						Cookies de publicidad comportamental: Almacenan información del
						comportamiento de los usuarios obtenida a través de la observación
						continuada de sus hábitos de navegación, lo que permite desarrollar
						un perfil específico para mostrar publicidad en función del mismo.
					</LegalListItem>
					<LegalListItem>
						Cookies de redes sociales externas: Se utilizan para que los
						visitantes puedan interactuar con el contenido de diferentes
						plataformas sociales (facebook, youtube, twitter, linkedIn, etc.) y
						que se generen únicamente para los usuarios de dichas redes
						sociales. Las condiciones de utilización de estas cookies y la
						información recopilada se regula por la política de privacidad de la
						plataforma social correspondiente.
					</LegalListItem>
				</LegalUnorderedList>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalHeading2>Desactivación y eliminación de cookies</LegalHeading2>

				<LegalParagraph>
					Tienes la opción de permitir, bloquear o eliminar las cookies
					instaladas en tu equipo mediante la configuración de las opciones del
					navegador instalado en su equipo. Al desactivar cookies, algunos de
					los servicios disponibles podrían dejar de estar operativos. La forma
					de deshabilitar las cookies es diferente para cada navegador, pero
					normalmente puede hacerse desde el menú Herramientas u Opciones.
					También puede consultarse el menú de Ayuda del navegador donde puedes
					encontrar instrucciones. Como usuario podrás en cualquier momento
					elegir qué cookies quieres que funcionen en el sitio web de{" "}
					{BUSINESS.name}.
				</LegalParagraph>
				<LegalParagraph>
					Puedes permitir, bloquear o eliminar las cookies instaladas en tu
					equipo mediante la configuración de las opciones del navegador
					instalado en tu ordenador o mediante herramientas especializadas. Es
					posible que algunas partes del sitio web no funcionen correctamente si
					deshabilitas las cookies.
				</LegalParagraph>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalHeading2>Aceptación de la Política de cookies</LegalHeading2>

				<LegalParagraph>
					{APP_PRODUCTION_URL}, asume que tú aceptas el uso de cookies. No
					obstante, muestra información sobre la Política de cookies en la parte
					inferior o superior de cualquier página del portal con cada inicio de
					sesión con el objeto de que tú seas consciente.
				</LegalParagraph>
				<LegalParagraph>
					Ante esta información es posible llevar a cabo las siguientes
					acciones:
				</LegalParagraph>

				<LegalUnorderedList>
					<LegalListItem>
						Aceptar cookies: No se volverá a visualizar este aviso al acceder a
						cualquier página del portal durante la presente sesión.
					</LegalListItem>
					<LegalListItem>
						Modificar su configuración: Podrá obtener más información sobre qué
						son las cookies, conocer la Política de cookies de:{" "}
						{APP_PRODUCTION_URL} y modificar la configuración de su navegador.
					</LegalListItem>
				</LegalUnorderedList>
			</LegalSection>
		</LegalContainer>
	)
}
